import { ReactElement, ElementType, useMemo } from 'react';

import { DashboardVariantV2GiverContextTabId } from '../../types';
import { useDashboardVariantV2GiverContext } from '../../Context';

import DashboardVariantV2GiverContenInPreparationTab from './InPreparation';
import DashboardVariantV2GiverContentInTransitTab from './InTransit';
import DashboardVariantV2GiverContentFinalizedTab from './Finalized';

const TABS_COMPONENTS: Record<
  DashboardVariantV2GiverContextTabId,
  ElementType
> = {
  inPreparation: DashboardVariantV2GiverContenInPreparationTab,
  inTransit: DashboardVariantV2GiverContentInTransitTab,
  finalized: DashboardVariantV2GiverContentFinalizedTab,
};

const DashboardVariantV2GiverContentTabs = (): ReactElement => {
  const {
    activeTab: { currentTab },
  } = useDashboardVariantV2GiverContext();

  const TabComponent = useMemo(() => TABS_COMPONENTS[currentTab], [currentTab]);

  return <TabComponent />;
};

export default DashboardVariantV2GiverContentTabs;
